module.exports = __webpack_public_path__ + "static/media/teaserhero-right-template.8c63575f.svg";